import { MaskedIcon } from '@/components/MaskedIcon/MaskedIcon';
import { NavigationButton } from '@/components/NewSidebar/components/NavigationButton';
import { SidebarRoute, useSidebarRoutes } from '@/components/NewSidebar/hooks/useSidebarRoutes';
import { useAnalytics } from '@/services/analytics';
import { AppRoutes } from '@/utils/types';
import styled from '@emotion/styled';
import { useLocation, useNavigate } from 'react-router-dom';
import home from '../images/home.svg';

const ButtonsContainer = styled.div`
    gap: 4px;
    display: flex;
    flex-direction: column;
    width: 100%;
    overflow: auto;
    padding: 0 16px;
`;

const Badge = styled.div`
    font-size: 12px;
    color: ${({ theme }) => theme.colors.primary.main};
    background-color: ${({ theme }) => theme.colors.primary.bgLight};
    border-radius: 555px;
    font-weight: 700;
    text-transform: capitalize;
    padding: 2px 6px;
    margin-left: -6px;
`;

const GroupName = styled.span`
    color: ${({ theme }) => theme.colors.black[600]};
    font-size: 12px;
    font-weight: 600;
    line-height: 20px; /* 166.667% */
    margin: 4px 16px 0;
`;

const Divider = styled.div`
    background-color: ${({ theme }) => theme.colors.black[200]};
    height: 1px;
`;

export const Navigation = () => {
    const location = useLocation();
    const mixpanel = useAnalytics();
    const navigate = useNavigate();
    const routes = useSidebarRoutes();

    const handleButtonClick = (route: SidebarRoute) => {
        mixpanel?.track?.('navigation', { event: 'click', label: route.label, ...route.extraAnalyticsData });
        route.newTab ? window.open(route.path, '_blank') : navigate(route.path);
    };

    const handleHomeClick = () => {
        mixpanel?.track?.('navigation', { event: 'click', label: 'Home' });
        navigate(AppRoutes.Home);
    };

    return (
        <ButtonsContainer>
            <NavigationButton id="sidebar-home" onClick={handleHomeClick} active={location.pathname === AppRoutes.Home}>
                <MaskedIcon src={home} size="24px" />
                Home
            </NavigationButton>
            <GroupName>Products</GroupName>
            {routes.map((route, i) => {
                if (route.id === 'divider') {
                    return <Divider key={`divider_${i}`} />;
                }

                return (
                    <NavigationButton
                        id={route.id}
                        key={route.id}
                        onClick={() => handleButtonClick(route)}
                        active={location.pathname === route.path}>
                        <MaskedIcon src={route.icon} size="24px" />
                        {route.label}
                        {route.isBeta && <Badge>Beta</Badge>}
                    </NavigationButton>
                );
            })}
        </ButtonsContainer>
    );
};
